import React from "react";
// Assets
import "~/assets/sass/pages/common/settingPage/settingPage.scss";
import "~/assets/sass/pages/common/settingPage/Modal/settingModal.scss";
import settingImg01 from "~/assets/img/bg-setting00-1.png";
import settingImg02 from "~/assets/img/bg-setting00-2.png";
import settingImg03 from "~/assets/img/bg-setting00-3.png";
import enSettingImg01 from "~/assets/img/EN/bg-setting00-1_en.png";
import enSettingImg02 from "~/assets/img/EN/bg-setting00-2_en.png";

import { useTranslation, Trans } from "react-i18next";

const ProcessOne = ({ retitle, handleTitle }) => {
	const { t, i18n } = useTranslation();

	return (
		<>
			<div className="side-content">
				<h3>
					<Trans
						i18nKey="pages.round.RoundSetting.processingModal.contents.ProcessOne.setting"
						components={[<br />]}
					/>
				</h3>
			</div>
			<section className="c__card">
				<div className="title">
					{t("pages.round.RoundSetting.processingModal.contents.ProcessOne.title")}
				</div>
				<input
					className="c__input title-input"
					value={retitle}
					name="title"
					onChange={handleTitle}
				/>

				<div className="setting-order">
					<p className="setting-order-title">
						{t("pages.round.RoundSetting.processingModal.contents.ProcessOne.way")}
					</p>
					<ul className="setting-order-step">
						<li>
							<div className="step-img">
								<img
									src={i18n.language === "ko" ? settingImg01 : enSettingImg01}
									alt={t(
										"pages.round.RoundSetting.processingModal.contents.ProcessOne.order"
									)}
								/>
							</div>
							<p>
								{t(
									"pages.round.RoundSetting.processingModal.contents.ProcessOne.stage1"
								)}
							</p>
							<p>
								{t(
									"pages.round.RoundSetting.processingModal.contents.ProcessOne.enrollCate"
								)}
							</p>
						</li>

						<li>
							<div className="step-img">
								<img
									src={i18n.language === "ko" ? settingImg02 : enSettingImg02}
									alt={t(
										"pages.round.RoundSetting.processingModal.contents.ProcessOne.order"
									)}
								/>
							</div>
							<p>
								{t(
									"pages.round.RoundSetting.processingModal.contents.ProcessOne.stage2"
								)}
							</p>
							<p>
								{t(
									"pages.round.RoundSetting.processingModal.contents.ProcessOne.enroll"
								)}
							</p>
						</li>
						<li>
							<div className="step-img">
								<img
									src={settingImg03}
									alt={t(
										"pages.round.RoundSetting.processingModal.contents.ProcessOne.order"
									)}
								/>
							</div>
							<p>
								{t(
									"pages.round.RoundSetting.processingModal.contents.ProcessOne.stage3"
								)}
							</p>
							<p>
								{t(
									"pages.round.RoundSetting.processingModal.contents.ProcessOne.weight"
								)}
							</p>
						</li>
					</ul>
				</div>
			</section>
		</>
	);
};

export default ProcessOne;
